import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { Navigate, useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (e2) { setErr(e2.response?.data?.detail || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="admin-shell min-h-screen grid place-items-center px-5">
      <form onSubmit={submit} className="admin-card w-full max-w-md p-8" data-testid="admin-login-form">
        <div className="text-center mb-7">
          <img src="/brand/rmorrison-logo.png" alt="RMorrison" className="h-16 w-auto mx-auto mb-3" />
          <p className="admin-eyebrow">Admin sign-in</p>
        </div>
        <div className="space-y-4">
          <div>
            <label className="admin-label">Email</label>
            <input className="admin-field" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
          </div>
          <div>
            <label className="admin-label">Password</label>
            <input className="admin-field" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
          </div>
          {err && <p className="border border-[#B5251A] bg-[#FFF1EE] text-[#B5251A] rounded-md p-2 text-sm" data-testid="login-error">{err}</p>}
          <button className="admin-btn w-full justify-center" disabled={loading} data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
        </div>
      </form>
    </div>
  );
}
